




































































































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import VueRouter, { Location } from "vue-router";
import { Validator } from "vee-validate";
import { PartnerAccountsMigrationModel, BankCustodian, PartnerListItem } from "@/admin/types";
import moment from "moment";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useDrivewealthAccountMigrationStore } from "@/shared/store/drivewealthAccountMigration";
import { usePartnerStore } from "@/admin/store/partner";

const zone = "America/Chicago";

@Component({ components: { GenericLoadingSpinner } })
export default class PartnerAccountsMigration extends Vue {
  moment = moment;
  today = moment().toDate();
  todayAsString = moment().format("YYYY-MM-DD");
  tomorrow = moment().add(1, "days").toDate();

  $router: VueRouter;
  $validator: Validator;
  newPartnerAccountsMigration: PartnerAccountsMigrationModel = {
    id: 0,
    partnerId: 0,
    dateStart: this.today,
    dateEnd: this.tomorrow,
    dateCreated: this.today,
    dateLastModified: this.today
  };
  @Prop() partnerId: number;

  isEditMode = false;
  isSubmitting = false;

  drivewealthAccountMigrationStore = useDrivewealthAccountMigrationStore();
  partnerStore = usePartnerStore();

  validateDateIsBefore = {
    getMessage () {
      return "Start Date must be before the End Date.";
    },
    validate (toDate, args) {
      if (args[0] === "null") {
        return true;
      }
      return moment(toDate).isBefore(args[0]);
    }
  };

  validateDateIsAfter = {
    getMessage () {
      return "End Date must be after the Start Date.";
    },
    validate (toDate, args) {
      if (args[0] === "null") {
        return true;
      }
      return moment(toDate).isAfter(args[0]);
    }
  };

  isTodayOrLater = {
    getMessage () {
      return "Date must be today or a later date.";
    },
    validate (toDate, args) {
      if (args[0] === "null") {
        return true;
      }
      return moment(toDate).isAfter(args[0]);
    }
  };

  mounted (): void {
    this.$validator.extend("validateDateIsBefore", this.validateDateIsBefore);
    this.$validator.extend("validateDateIsAfter", this.validateDateIsAfter);
    this.$validator.extend("isTodayOrLater", this.isTodayOrLater);
    this.drivewealthAccountMigrationStore.loadPartnerAccountsMigration(this.partnerId).then(() => {
      this.reloadFormData();
    });
    if (!this.partnerStore.isLoaded) {
      this.partnerStore.reload();
    }
  }

  get submitDisabled () {
    return this.$validator.errors.any() || this.isSubmitting;
  }

  get isAllLoaded () {
    return this.drivewealthAccountMigrationStore.partnerAccountsMigrationLoaded && this.partnerStore.isLoaded;
  }

  get isViewMode () {
    return !this.isEditMode;
  }

  get hasExistingMigration () {
    return this.drivewealthAccountMigrationStore.currentPartnerAccountMigration.id !== 0;
  }

  get migrationPeriodInDays () {
    const start = moment(this.newPartnerAccountsMigration.dateStart).startOf("day");
    const end = moment(this.newPartnerAccountsMigration.dateEnd).startOf("day");
    const diffInDays = moment.duration(end.diff(start)).asDays();
    if (diffInDays < 1) {
      return "0";
    }
    return Math.round(diffInDays);
  }

  get isHsaBankCustodian () {
    return this.partnerStore.isHsabCustodian(this.partnerId);
}

get isUsingDrivewealthAsInvestmentProvider () {
    return this.partnerStore.hasDrivewealthAsInvestmentProvider(this.partnerId);
  }

  switchToEditMode () {
    this.isEditMode = true;
  }

  switchToViewMode () {
    this.isEditMode = false;
  }

  reloadFormData () {
    this.newPartnerAccountsMigration.partnerId = this.partnerId;
    this.newPartnerAccountsMigration.id = this.drivewealthAccountMigrationStore.currentPartnerAccountMigration.id;
    this.newPartnerAccountsMigration.dateStart
        = this.drivewealthAccountMigrationStore.currentPartnerAccountMigration.dateStart;
    this.newPartnerAccountsMigration.dateEnd
        = this.drivewealthAccountMigrationStore.currentPartnerAccountMigration.dateEnd;
  }

  onSubmit () {
    this.$validator.validateAll().then(valid => {
      if (valid) {
        this.isSubmitting = true;
        if (this.hasExistingMigration) {
          this.drivewealthAccountMigrationStore.updatePartnerAccountsMigration(this.newPartnerAccountsMigration)
              .then(resp => {
                this.isSubmitting = false;
                this.switchToViewMode();
              });
        } else {
          this.drivewealthAccountMigrationStore.createPartnerAccountsMigration(this.newPartnerAccountsMigration)
              .then(resp => {
                this.isSubmitting = false;
                this.switchToViewMode();
              });
        }
      }
    });
  }
}
